import { render } from "./ComandosXeon.vue?vue&type=template&id=6a43281f&scoped=true"
import script from "./ComandosXeon.vue?vue&type=script&lang=js"
export * from "./ComandosXeon.vue?vue&type=script&lang=js"

import "./ComandosXeon.vue?vue&type=style&index=0&id=6a43281f&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a43281f"]])

export default __exports__